import css from "./ResultsCount.module.scss";

export interface ResultsCountProps {
    visible: number | undefined;
    total: number | undefined;
}

export const ResultsCount: React.FC<ResultsCountProps> = ({
    visible,
    total
}) => {
    if (visible === undefined || total === undefined) {
        return null;
    }
    return (
        <span className={css["count"]}>
            Showing <b>{visible.toLocaleString()}</b> of{" "}
            {total.toLocaleString()} rows
        </span>
    );
};
